<template>
  <div class="update-class-date">
    <Modal
      v-model="editShow"
      title="编辑"
      :width="900"
      :mask-closable="false"
      :footer-hide="true"
      :draggable="true"
      :closable="false"
    >
      <div v-if="editShow">
        <Form
          ref="editInfoForm"
          class="class-form-divide"
          :model="editInfo"
          :rules="ruleEditInfo"
          :label-width="110"
        >
          <FormItem label="上课场地" prop="placeId">
            <PlaceSelect
              ref="placeSelectRef"
              v-model="editInfo"
              class="class-form-item-inline"
              :org-id="schoolId"
              :branch-id="branchId"
            ></PlaceSelect>
            <!-- <PlaceModal
              v-model="placeData"
              :org-id="schoolId"
              :branch-id="branchId"
              @postPlaceId="getPlaceId"
            ></PlaceModal> -->
          </FormItem>
          <FormItem label="开课日期" prop="beginDate">
            <DatePicker
              :value="editInfo.beginDate"
              type="date"
              placeholder="选择开课日期"
              class="class-form-item-inline"
              @on-change="handleGetBeginDate"
            ></DatePicker>
          </FormItem>
          <FormItem label="上课时间" prop="beginTime">
            <TimePicker
              :value="editInfo.beginTime"
              :steps="[1, 5]"
              :disabled-hours="[0, 1, 2, 3, 4, 5, 23, 24]"
              hide-disabled-options
              class="time-block"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="请选择上课起止时间"
              @on-change="handleGetBeginTime"
              @on-open-change="onTimeOpenChange"
            ></TimePicker>
          </FormItem>
          <FormItem label="授课教师" prop="teacher">
            <div v-if="editInfo.teacher.length > 0" class="data-line">
              <span>{{ teachersName }}</span>
              <span
                class="change-btn"
                @click="handleOpenTeacher"
              >重新选择</span>
            </div>
            <div v-else class="class-add-btn" @click="handleOpenTeacher">
              选择教师
            </div>
            <Modal
              v-model="modalShow"
              :width="800"
              title="选择教师"
              :footer-hide="true"
              :closable="false"
            >
              <RadioOrCheckboxTable
                v-model="selectTableData"
                :table-column="teacherColumn"
                :table-data="selectTeacherList"
                :table-total="selectTeacherList.length"
                :table-current="1"
                :select-type="2"
                unique-key="teacherId"
              ></RadioOrCheckboxTable>
              <div class="modal-footer">
                <Button @click="handleCancleBtn">取消</Button>
                <Button type="primary" @click="handleSureBtn">确定</Button>
              </div>
            </Modal>
          </FormItem>
        </Form>
      </div>
      <Alert type="warning">
        <p>①如果该上课日期已结算，则不允许调整上课时间</p>
        <p>②如果调整至的月份已结算，则不允许调整</p>
        <p>
          ③如果该上课时间<span>存在</span>对应的学生请假单，则系统会<span>自动撤销该请假单</span>，请调整前仔细核对。
        </p>
      </Alert>
      <div class="btn-box">
        <Button @click="editShow = false">取消</Button>
        <Button
          :disabled="classLoading"
          type="primary"
          @click="handleCheckEditInfo"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import schoolAdmin from '@/request/schoolAdmin/index.js';
import { teacherColumn } from '../data/updateClassDate';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { timeToStr, timeToYearStr } from '@/utils/utils.js';
import RadioOrCheckboxTable from '@c/Base/RadioOrCheckboxTable.vue';
import PlaceSelect from './PlaceSelect.vue';
export default {
  name: 'UpdateClassDate',
  components: {
    PlaceSelect,
    RadioOrCheckboxTable
  },
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    branchId: {
      type: String,
      default: ''
    },
    classroomId: {
      type: String,
      default: ''
    },

    detailId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editShow: false,
      teacherColumn: teacherColumn,
      selectTeacherList: [], // 可以选择的教师列表
      editInfo: {
        placeId: '', // 上课场地的id
        placeName: '', // 上课场地名称
        beginDate: null, // 开课日期
        beginTime: null, // 上课时间
        teacher: [] // 授课老师
      },
      ruleEditInfo: {
        placeId: [
          { message: '请选择上课场地', trigger: 'blur' }
        ],
        beginDate: [
          { required: true, message: '请输入开课日期', trigger: 'change' }
        ],
        beginTime: [
          {
            required: true,
            type: 'array',
            min: 2,
            message: '请输入上课时间',
            trigger: 'change'
          }
        ],
        teacher: [
          { type: 'array', min: 1, message: '请选择授课老师', trigger: 'change' }
        ]
      },
      placeData: {},
      teachersName: '',
      classLoading: false, // 添加或者编辑课次正在进行中
      selectTableData: [], // 选中的教师数据
      modalShow: false, // 教师弹窗是否展示
      beforeBeginDate: '',
      beforeBeginTime: []
    };
  },

  methods: {
    async handleOpen(row) {
      this.$Spin.show();
      await this.getTeacherData();
      this.editShow = true;
      this.$Spin.hide();
      this.handleRowData(row);
    },
    onTimeOpenChange(status) {
      if (status) {
        setTimeout(() => {
          const dom = document.querySelectorAll('.ivu-time-picker-cells-list');
          for (let i = 0, len = dom.length; i < len; i++) {
            dom[i].scrollTop = 0;
          }
        }, 300);
      }
    },
    // 处理数据时间
    handleRowData(row) {
      if (+row.placeId === 0 && row.placeName) {
        this.editInfo.placeId = row.placeName;
        this.editInfo.placeName = row.placeName;
      } else {
        this.editInfo.placeId = row.placeName ? row.placeId : '';
      }

      this.editInfo.beginDate = timeToYearStr(row.classDate);
      this.editInfo.beginTime = [
        timeToStr(row.classTimeBegin),
        timeToStr(row.classTimeEnd)
      ];
      this.beforeBeginDate = this.editInfo.beginDate;
      this.beforeBeginTime = this.editInfo.beginTime;
      this.editInfo.teacher = row.teachers;
      this.teachersName = row.teacherDesc;
      // this.selectTeacherList = this.selectTeacherList.map(item => {
      //   const itemIndex = row.teachers.findIndex(x => {
      //     return x.teacherId === item.teacherId;
      //   });
      //   item._checked = itemIndex !== -1;
      //   return item;
      // });
      // this.placeData = {
      //   id: row.placeId,
      //   placeId: row.placeId,
      //   placeName: row.placeName
      // };
    },
    // 获取选择的日期
    handleGetBeginDate(date, _) {
      this.editInfo.beginDate = date;
    },
    handleGetBeginTime(time) {
      // console.log(time);
      this.editInfo.beginTime = time;
    },
    /** === 有关选择场地start ===**/
    getPlaceId(id) {
      this.editInfo.placeId = id;
    },
    handleOpenTeacher() {
      const listData = [];
      this.selectTeacherList.forEach(item => {
        const itemIndex = this.editInfo.teacher.findIndex(x => {
          return x.teacherId === item.teacherId;
        });
        itemIndex !== -1 ? listData.push(item) : '';
        return item;
      });
      this.selectTableData = listData;
      this.modalShow = true;
    },
    // 点击取消按钮
    handleCancleBtn() {
      this.modalShow = false;
    },
    // 点击确定按钮
    handleSureBtn() {
      this.editInfo.teacher = this.selectTableData;
      const teacherArr = this.selectTableData.map(item => {
        return item.userName;
      });
      this.teachersName = teacherArr.join(',');
      this.modalShow = false;
    },
    // 打开弹窗
    openModal(name, id) {
      this.$refs[name].open(id);
    },
    getSelectTeacherData(teacherData) {
      console.log(teacherData, '---==---');
      this.editInfo.teacher = teacherData;
      const teacherArr = teacherData.map(item => {
        return item.userName;
      });
      this.teachersName = teacherArr.join(',');
    },
    async getTeacherData() {
      return new Promise(async(resolve, reject) => {
        const params = {
          classroomId: this.classroomId,
          teacherSts: 1
        };
        const res = await courseSchedulCenter.getClassPartitionTeachers(params);
        if (res.status === 200) {
          this.selectTeacherList = res.message.map(item => {
            item.userName = item.teacherName;
            item.deptName = item.orgName;
            return item;
          });
          resolve();
        } else {
          reject();
        }
      });
    },
    // 获取场地列表
    async getPlaceListData() {
      const params = {
        orgId: this.baseInfo.schoolId, // 学校id
        branchId: this.selectCourseGoodsData.branchId, // 校区id
        placeSts: 1, // 场地状态 1：启用 0：禁用
        pageNum: this.placePageInfo.pageNum,
        pageSize: this.placePageInfo.pageSize
      };
      const res = await schoolAdmin.getPlacesQuerylist(params);
      if (res.status === 200) {
        this.placeList = res.message.list.map(item => {
          item.id = item.placeId;
          return item;
        });
        this.placePageInfo.total = Number(res.message.total);
      }
    },
    // 获取选择到的场地
    getSelectPlaceInfo(row) {
      this.baseInfo.placeId = row.placeId;
      this.selectPlaceData = row;
    },
    // 编辑弹窗点击确定按钮

    /** === 有关选择场地end ===**/
    handleCheckEditInfo() {
      this.classLoading = true;
      this.$refs.editInfoForm.validate(async(valid) => {
        if (valid) {
          if (this.editInfo.beginTime[0] === this.editInfo.beginTime[1]) {
            this.$Message.error('上课结束时间不能与上课开始时间相同！');
            this.classLoading = false;
            return;
          }
          this.$Spin.show();
          const tag = await this.beforeEdit();

          if (tag === 1) {
            this.$Spin.hide();
            this.$Modal.confirm({
              title: '提示',
              content: `<p>原上课日期：${this.beforeBeginDate}  已存在学生的待审批请假单或已审批

                请假单信息，是否确认继续调整上课时间？</p>

                <p>确定后，系统将执行对应请假单的撤销操作，该操作不可恢复！

                请确认前仔细核对。</p>`,
              onOk: () => {
                this.submitEditInfo();
              },
              onCancel: () => {
                this.classLoading = false;
              }
            });
          } else if (tag === 0) {
            this.submitEditInfo();
          } else {
            this.$Spin.hide();
            this.classLoading = false;
          }
        } else {
          this.classLoading = false;
        }
      });
    },
    async beforeEdit() {
      return new Promise(async(resolve, reject) => {
        const dateSame = this.beforeBeginDate === this.editInfo.beginDate;
        const timeSame = JSON.stringify(this.beforeBeginTime) === JSON.stringify(this.editInfo.beginTime);
        // if (dateSame && timeSame) {
        //   resolve(false);
        //   return;
        // }
        let tag = 0;
        // const params = {
        //   detailId: this.detailId
        // };
        const formData = new FormData();
        formData.append('detailId', this.detailId);
        const res = await courseSchedulCenter.getLeaveListFromDetailIdApi(formData);
        if (res.status === 200 && res.message) {
          // 如果该节次已存在对应的请假单（已通过leaveState1、待审批leaveState0）的，点击确认后，则进行二次弹框提示
          // const tagTrue = res.message.some(item => {
          //   return (+item.leaveState) === 0 || (+item.leaveState) === 1;
          // });
          tag = res.message.length > 0 ? 1 : 0;
          // tag = true;
        } else {
          tag = -1;
        }
        resolve(tag);
      });
    },
    // 提交编辑信息
    async submitEditInfo() {
      try {
        const teacherIds = this.editInfo.teacher.map(item => {
          return item.teacherId;
        });
        let { placeName, placeId, ...paramsS } = this.editInfo;
        if (placeName !== '' && placeName === placeId) {
          placeId = 0;
        }

        const params = {
          detailId: this.detailId,
          placeId: placeId,
          classBeginDate: `${this.editInfo.beginDate} 00:00:00`, // 上课日期
          classTimeBegin: `${this.editInfo.beginDate} ${this.editInfo.beginTime[0]
          }:00`, // 上课时间-时分秒
          classTimeEnd: `${this.editInfo.beginDate} ${this.editInfo.beginTime[1]
          }:00`, // 上课时间-时分秒
          teacherIds: teacherIds // 上课老师
        };
        placeName ? params.placeName = placeName : '';
        if (placeId) {
          params.placeName = this.$refs.placeSelectRef.getPlaceName();
        } else {
          params.placeName = placeName;
        }
        // return console.log(params, '编辑参数');
        this.$Spin.show();
        const res = await courseSchedulCenter.postClassDetailUpdateApi(params);

        if (res.status === 200) {
          this.editShow = false;
          this.$Message.success('编辑成功!');
          this.$emit('on-submit-finish');
        }
        this.$Spin.hide();
      } catch (err) {
        console.log(err);
      } finally {
        this.classLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-box {
  margin-top: 24px;
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 16px;
  }
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  button + button {
    margin-left: 8px;
  }
}
p {
  line-height: 25px;
  span {
    color: red;
  }
}
</style>
